import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { primary, secondary },
    breakpoints
  } = theme;

  return {
    contentHeader: {
      width: "100%",
      height: 42,
      borderBottom: `1px solid ${primary.light}`
    },
    tabs: {
      width: 307,
      minHeight: 42,
      "& .MuiTab-root.Mui-selected": {
        color: secondary.dark
      },
      [breakpoints.down(Breakpoints.SM_600)]: {
        width: "100%"
      }
    },
    tab: {
      height: 42,
      width: "50%",
      minHeight: 42,
      fontSize: 12,
      minWidth: 150,
      [breakpoints.down(Breakpoints.SM_600)]: {
        minWidth: "50%",
        fontSize: 14
      }
    },
    activeTab: {
      backgroundColor: secondary.dark
    }
  };
});
